import React from "react";
import { NextSeo } from "next-seo";
import Navbar from "@/features/LandingPage/Navbar";
import Hero from "@/features/LandingPage/Hero";
import Content from "@/features/LandingPage/Content";
import FeatureDataTable from "@/features/LandingPage/FeatureDataTable";
import Signup from "@/features/LandingPage/Signup";
import FAQ from "@/features/LandingPage/FAQ";
import Footer from "@/features/LandingPage/Footer";
import Pricing from "@/features/LandingPage/Pricing";
import useNotifier from "@/hooks/useNotifier";
import UseCases from "@/features/LandingPage/UseCases";
import HowItWorks from "@/features/LandingPage/WhyFundview";

function Home() {
  useNotifier();

  return (
    <>
      <NextSeo
        title="Fundview"
        description="Deal flow software designed for CRE loan brokers."
        canonical="https://www.fundview.com/"
        openGraph={{
          url: "https://www.fundview.com/",
          title: "Fundview",
          description: "Deal flow software designed for CRE loan brokers.",
          type: "website",
          images: [
            {
              url: "https://www.fundview.com/fv_seo_icon.png",
              width: 585,
              height: 593,
              alt: "Fundview Logo",
              type: "image/png",
            },
          ],
          siteName: "Fundview",
        }}
      />

      <div className="overflow-x-hidden bg-gray-50">
        <Navbar />
        <Hero />
      </div>

      <Content />
      <HowItWorks />
      <UseCases />
      <FeatureDataTable />
      <Pricing />
      <Signup />
      <FAQ />
      <Footer />
    </>
  );
}

export default Home;
